import { RampWithNameTransform } from '@goldwasserexchange/react-topmodel';
import * as React from 'react';
import { useTableWrapping } from '../../context';
import { groupNamesByWrapping } from '../../context/wrapping/constants';
export var TableFooterContent = function () {
    var wrapping = useTableWrapping();
    return (React.createElement(RampWithNameTransform, { rampName: "Footer".concat(groupNamesByWrapping[wrapping], "Container") },
        React.createElement(RampWithNameTransform, { rampName: "Footer".concat(groupNamesByWrapping[wrapping], "Content") })));
};
